import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "layout-main" },
    [
      _c("div", { staticClass: "layout-actions" }, [
        _c(
          "button",
          { staticClass: "layout-button", on: { click: _vm.expandAll } },
          [
            _c(
              VIcon,
              { staticClass: "material-icons-outlined ml-1 layout-icon" },
              [_vm._v("open_in_full")]
            ),
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("grid.layouts.sidebar.expandAll")) +
                "\n    "
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "layout-button", on: { click: _vm.collapseAll } },
          [
            _c(
              VIcon,
              { staticClass: "material-icons-outlined ml-1 layout-icon" },
              [_vm._v("close_fullscreen")]
            ),
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("grid.layouts.sidebar.collapseAll")) +
                "\n    "
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "layout-content" },
        [
          _c("layout-options", {
            staticClass: "mb-2",
            attrs: {
              "active-layout-name": _vm.activeLayoutName,
              "has-active-layout": _vm.hasActiveLayout,
              "can-edit": _vm.canEditActiveLayout,
              "is-recommended-layout": _vm.isActiveLayoutRecommended,
            },
            on: { save: _vm.saveLayout, update: _vm.updateLayout },
          }),
          _vm._v(" "),
          _c("ag-grid-vue", {
            staticClass: "ag-theme-custom ag-theme-custom--layouts flex-grow-1",
            staticStyle: { width: "100%" },
            attrs: {
              "column-defs": _vm.columnDefs,
              "row-data": _vm.layoutData,
              "group-display-type": _vm.groupDisplayType,
              "group-default-expanded": -1,
              "grid-options": _vm.gridOptions,
            },
            on: {
              "grid-ready": _vm.onGridReady,
              "row-clicked": _vm.onRowClicked,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("confirm-dialog", {
        attrs: {
          "is-open": _vm.isDeleteLayoutDialogOpen,
          "ok-btn-text": _vm.$t("actions.delete"),
          "cancel-btn-text": _vm.$t("actions.cancel"),
        },
        on: { onOk: _vm.confirmDeleteLayout, onCancel: _vm.cancelDeleteLayout },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c("div", { staticClass: "delete-layout-message" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("grid.layouts.deleteLayout.message", {
                          name: _vm.layoutToDeleteName,
                        })
                      ) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "delete-layout-submessage" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("grid.layouts.deleteLayout.submessage")) +
                      "\n      "
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }